/**
 * Created by rathompson on 11/5/21
 * File: link
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */


/**
 *   Link text component
 */
const Link = ({ children, onClick, href, target }) => (
  <a className='tw-text-link tw-text-base tw-cursor-pointer tw-text-default tw-truncate' {...{ onClick, href, target }}>
    {children}
  </a>
)

Link.propTypes = {}
export default Link
